import { create } from 'zustand'
import type { CloudUser, CloudTenant } from '../types'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: CloudUser | null
  tenant: CloudTenant | null
  isInitialized: boolean

  setTokens: (access: string, refresh: string) => void
  setUser: (user: CloudUser, tenant?: CloudTenant) => void
  logout: () => void
  setInitialized: () => void
}

export const useAuthStore = create<AuthState>()(
  (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      tenant: null,
      isInitialized: false,

      setTokens: (access, refresh) => {
        set({ accessToken: access, refreshToken: refresh })
      },

      setUser: (user, tenant) =>
        set((state) => ({
          user,
          tenant: tenant ?? state.tenant,
        })),

      logout: () => {
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          tenant: null,
        })
      },

      setInitialized: () => set({ isInitialized: true }),
  })
)
